<template>
  <div id="lm-component-loading" :class="{fixed}" :style="[position, backgroundColor,zIndex]">
    <img src="@/assets/images/LmComponentLoading.svg" alt="loading" />
  </div>
</template>

<script>
export default {
  props: {
    top: Number,
    left: Number,
    right: Number,
    bottom: Number,
    /**
     * Estilo fixed para la imagen del loading, esto quiere decir que la img siempre va a ser visible, sin importar cuan largo es el componente que realiza el loading
    */
    fixed: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: Object,
      default: () => ({ background: 'white' })
    },
    zIndex: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    position () {
      let measure = 'px'
      let style = ''
      if (this.top) {
        style += `top:${this.top}${measure}`
      }
      if (this.left) {
        style += `left:${this.left}${measure}`
      }
      if (this.right) {
        style += `right:${this.right}${measure}`
      }
      if (this.bottom) {
        style += `bottom:${this.bottom}${measure}`
      }
      return style
    }
  }
}
</script>

<style scoped>
  #lm-component-loading {
  background: white;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: var(--zIndexLmComponentLoading);
}

#lm-component-loading img {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  fill: var(--primaryThemeColor);
}

#lm-component-loading.fixed img {
  position: fixed;
}
</style>
